import type { HudState } from './types';
import { useI18n } from '../../i18n';

interface DemoControlsProps {
  hudState: HudState;
  onSetHudState: (state: HudState) => void;
  onToggleVisibility: () => void;
  onOpenFullSheet: () => void;
  onResetStore: () => void;
}

const STATE_BUTTONS: { state: HudState; labelKey: 'characterHud.demoPill' | 'characterHud.demoCombat' }[] = [
  { state: 'compact', labelKey: 'characterHud.demoPill' },
  { state: 'battle', labelKey: 'characterHud.demoCombat' },
];

export function DemoControls({
  hudState,
  onSetHudState,
  onToggleVisibility,
  onOpenFullSheet,
  onResetStore,
}: DemoControlsProps) {
  const { t } = useI18n();

  return (
    <div
      className="fixed flex flex-col gap-1.5 p-3 rounded-lg"
      style={{
        top: 16,
        left: 16,
        zIndex: 'var(--z-panel)',
        backgroundColor: 'rgba(0,0,0,0.9)',
        color: '#e4e4e7',
        fontSize: 12,
      }}
    >
      <span className="text-xs font-semibold opacity-60">{t('characterHud.demoTitle')}</span>

      {/* State buttons */}
      <div className="flex gap-1">
        {STATE_BUTTONS.map(({ state, labelKey }) => (
          <button
            key={state}
            className="px-2 py-1 rounded text-xs"
            style={{
              backgroundColor: hudState === state ? '#d9455f' : 'rgba(255,255,255,0.1)',
              color: hudState === state ? '#fff' : '#e4e4e7',
            }}
            onClick={() => onSetHudState(state)}
          >
            {t(labelKey)}
          </button>
        ))}
      </div>

      {/* Utility buttons */}
      <div className="flex gap-1 flex-wrap">
        <button
          className="px-2 py-1 rounded text-xs"
          style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
          onClick={onToggleVisibility}
        >
          {t('characterHud.demoToggle')}
        </button>
        <button
          className="px-2 py-1 rounded text-xs"
          style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
          onClick={onOpenFullSheet}
        >
          {t('characterHud.demoFullSheet')}
        </button>
        <button
          className="px-2 py-1 rounded text-xs"
          style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
          onClick={onResetStore}
        >
          {t('characterHud.demoReset')}
        </button>
      </div>
    </div>
  );
}
